<cmv-modal-base positionContent="bottom" [isModalOpen]="isModalOpen">
	<section class="device-permission">
		<h1 class="device-permission__title">
			validaremos tu <span>identidad</span>
		</h1>

		<section class="device-permission__reason">
			<b>Necesitamos acceso a los siguientes permisos</b>
		</section>
		<cmv-base-card class="device-permission__permissions">
			<ul class="device-permission__permissions-options">
				<li
					*ngFor="let permission of permissions; trackBy: permissionTrackBy"
					[attr.type]="permission.type"
					[attr.active]="permission.isEnabled">
					{{ permission.name }}
				</li>
			</ul>
		</cmv-base-card>
		<section class="device-permission__security-message">
			<b>Tu seguridad es nuestra prioridad.</b>
			<p>
				Tu información está protegida y se usará únicamente para mejorar tu
				experiencia.
			</p>
		</section>
		<button
			cmvBtn="action"
			[disabled]="!isContinueButtonEnabled"
			(click)="onContinue()">
			{{ continueButtonText }}
			<cmv-loader *ngIf="isGettingPermissions" [size]="'small'"></cmv-loader>
		</button>
	</section>
	<cmv-modal-base *ngIf="isNoticeModalVisible">
		<section class="device-permission__notice">
			<h1>Aviso</h1>
			<p>
				Debido a que no has aceptado el permiso de
				<strong>{{ deniedPermissions }}</strong
				>, podrías tener problemas para continuar con el proceso de validación
				de identidad
			</p>
			<button cmvBtn="action" (click)="onCloseNotice()">OK</button>
		</section>
	</cmv-modal-base>
</cmv-modal-base>
